import Modal from 'react-bootstrap/Modal'
import {Form, Formik} from "formik";
import {TextField} from "../../components/common/TextField/TextField";
import React, {useEffect, useState} from "react";
import {OptionList} from "../../components/common/OptionList/OptionList";
import {Col, Row} from "react-bootstrap";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { DateRangePickerComponent, TimePickerComponent } from "@syncfusion/ej2-react-calendars";
import dateFormat from "dateformat";
import {dateFormatToDb, filesTo, productsAPI} from "../../api/api";
import ShowNotification from "../../components/common/Notification/ShowNotification";
import style from "./AddDataModal.Module.css";

const EditDataModal = ({show, setIsEditProduct, deleteProductTh, productTypes, eventTypes, products, updateProductTh, productId, ...props}) => {

    let product = products.find((item) => item.productId === parseInt(productId));

    // Admin detalları — status filteri yoxdur, deaktiv məhsul da gəlir
    useEffect(() => {
        let isMounted = true;
        if (productId) {
            productsAPI.getProductById(productId).then(data => {
                if (isMounted && data && data.product) {
                    // Detallar gəldikdə formanı yeniləyirik
                    setContent(data.product.content || "");
                    setImageUrl(data.product.imgUrl || "");
                    setStatus(data.product.status !== undefined ? data.product.status : 1);
                }
            });
        }
        return () => { isMounted = false; };
    }, [productId]);

    let [showModal, setShowModal] = useState(show)
    let [showDeleteModal, setShowDeleteModal] = useState(false)

    const [fromdate, setFromDate] = useState(product?.startDate ? product.startDate.substring(0, 10) : "")
    const [todate, setToDate] = useState(product?.endDate ? product.endDate.substring(0, 10) : "")
    const [fromHour, setFromHour] = useState(product?.startDate ? product.startDate.substring(11) : "00:00:00")
    const [toHour, setToHour] = useState(product?.endDate ? product.endDate.substring(11) : "00:00:00")

    const [fileUploadClicked, setFileUploadClicked] = useState(false)
    const [submitClicked, setSubmitClicked] = useState(false)
    let [content, setContent] = useState(product?.content || "")
    let [selectedFile, setSelectedFile] = useState()
    let [imageUrl, setImageUrl] = useState(product?.imgurl || "")

    let [productTyp, setProductType] = useState(product?.productType || "")
    let [eventTyp, setEventType] = useState(product?.eventTypeId || "")
    let [status, setStatus] = useState(product?.status !== undefined ? product.status : 1)

    const handleClose = () => {
        setIsEditProduct(false)
    }

    useEffect(() => {
        if (product) {
            setFromDate(product.startDate ? product.startDate.substring(0, 10) : "");
            setToDate(product.endDate ? product.endDate.substring(0, 10) : "");
            setFromHour(product.startDate ? product.startDate.substring(11) : "00:00:00");
            setToHour(product.endDate ? product.endDate.substring(11) : "00:00:00");
            setContent(product.content || "");
            setImageUrl(product.imgurl || "");
            setProductType(product.productType || "");
            setEventType(product.eventTypeId || "");
            setStatus(product.status !== undefined ? product.status : 1);
        }
    }, [productId, product]);

    useEffect(() => {
        if (show) setShowModal(true)
        else setShowModal(false)
    }, [show])

    const saveCkEditorHTML = (e, editor) => {
        setContent(editor.getData())
    }

    const UploadFile = async (file) => {
        if (!file) {
            ShowNotification("Xəbərdarlıq", "Zəhmət olmasa əvvəlcə fayl seçin", "warning")
            return
        }
        setFileUploadClicked(true)
        setSubmitClicked(false)
        const responseFileLoad = await filesTo.add(file, "products")
        if (responseFileLoad && responseFileLoad.status === 200) {
            ShowNotification("Success", "File uploaded", "success")
            const filePath = "files/" + responseFileLoad.data.url
            setImageUrl(filePath)
        } else {
            ShowNotification("Error", responseFileLoad?.data?.message || "Fayl yüklənmədi", "danger")
        }
    }

    let statList = [
        {id: 0, name: 'Deactive', status: 1},
        {id: 1, name: 'Active', status: 1}
    ]

    let productInstance = {
        productId: 1,
        title: "title 3",
        content: "content 3",
        imgUrl: "100",
        youtubeLink: "1010",
        status: 1,
        productType: 1,
        eventType: 1,
        price: "1500.00",
        startDate: "2021-06-28 14:00:00",
        endDate: "2021-08-28 18:00:00",
    }

    if (!product) {
        return null;
    }

    return (
        <Formik
            initialValues={{
                productId: product.productId ? product.productId : '',
                name: product.name ? product.name : '',
                title: product.title ? product.title : '',
                content: product.content ? product.content : '',
                imgUrl: imageUrl ? imageUrl : '',
                youtubeLink: product.youtubeLink ? product.youtubeLink : '',
                status: status ? status : '',
                productType: productTyp,
                eventType: eventTyp,
                price: product.price ? product.price : '',
                startDate: product.startDate ? product.startDate : '',
                endDate: product.endDate ? product.endDate : '',
            }}
            onSubmit={(formValues) => {
                if (submitClicked) {
                    productInstance.productId = formValues.productId
                    productInstance.title = formValues.title
                    productInstance.content = content
                    productInstance.status = parseInt(status)

                    if (imageUrl !== undefined) productInstance.imgUrl = imageUrl
                    else productInstance.imgUrl = formValues.imgUrl

                    productInstance.youtubeLink = formValues.youtubeLink.replace("watch?v=", "embed/")
                    productInstance.productType = parseInt(productTyp)
                    productInstance.eventType = parseInt(eventTyp)
                    productInstance.price = formValues.price
                    productInstance.startDate = fromdate + " " + fromHour
                    productInstance.endDate = todate + " " + toHour
                    // status göndərilməzsə backend mövcud statusu saxlayır
                    productInstance.status = parseInt(status)

                    updateProductTh(productInstance);
                    setIsEditProduct(false)
                }
            }}
        >
            {props => (
                <>
                    <Modal size="sm" show={showDeleteModal}>
                        <Modal.Body closeButton>
                            <Modal.Title>Məhsulun deaktiv edilməsini təsdiqləyin</Modal.Title>
                        </Modal.Body>
                        <Modal.Footer className='text-center'>
                            <button type="reset"
                                    className="btn btn-warning mr-3"
                                    onClick={() => {
                                        deleteProductTh(productId)
                                        setIsEditProduct(false)
                                        setShowDeleteModal(false)
                                    }}
                                    data-dismiss="modal">Deaktiv et</button>
                            <button type="submit"
                                    onClick={() => {
                                        setShowDeleteModal(false)
                                        setIsEditProduct(false)
                                    }}
                                    className="btn btn-primary">Geri Qayıt</button>
                        </Modal.Footer>
                    </Modal>

                    <Modal size="md" show={showModal} onHide={handleClose} autoFocus={true} restoreFocus={true}>
                        <Modal.Header closeButton>
                            <Modal.Title>Mehsul redaktə et</Modal.Title>
                        </Modal.Header>
                        <Form>
                            <Modal.Body>
                                <TextField label="Məhsulun Adı" name="title" type="text" enableLabel='true' />

                                <label>Kontent</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={content || ""}
                                    name="content"
                                    onChange={saveCkEditorHTML}
                                />

                                <label>Tarix aralığı</label>
                                <Row className="col-12 mr-2 m-0 p-0 align-items-center">
                                    <Col xs={6}>
                                        <div className="col-12 align-self-end m-0 p-0">
                                            <DateRangePickerComponent
                                                id="daterangepicker"
                                                format='dd/MM/yyyy'
                                                name="daterangepicker"
                                                startDate={new Date(fromdate)}
                                                endDate={new Date(todate)}
                                                onChange={(event) => {
                                                    if (event.value && event.value.length === 2) {
                                                        let startDate = event.value[0]
                                                        startDate = dateFormat(startDate, "yyyy-mm-dd")
                                                        setFromDate(startDate)

                                                        let endDate = event.value[1]
                                                        endDate = dateFormat(endDate, "yyyy-mm-dd")
                                                        setToDate(endDate)
                                                    }
                                                }}
                                                placeholder='Gün aralığı seç'
                                            />
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div>
                                            <Row>
                                                <Col>
                                                    <Row>
                                                        <span className="badge badge-light mt-2 pt-2">from</span>
                                                        <Col className={`mt-2 m-0 p-0 ${style.times}`}>
                                                            <TimePickerComponent
                                                                name="fromHour"
                                                                onChange={(event) => {
                                                                    let timeFrom = event.target.value
                                                                    if (timeFrom !== null) {
                                                                        timeFrom = timeFrom.toString().substr(16, 8)
                                                                        setFromHour(timeFrom)
                                                                    }
                                                                }}
                                                                value={fromHour}
                                                                format={'HH:mm'}
                                                                placeholder="saat"
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    <Row>
                                                        <span className="badge badge-light mt-2 pt-2">to</span>
                                                        <Col className={`mt-2 m-0 p-0 ${style.times}`}>
                                                            <TimePickerComponent
                                                                name="toHour"
                                                                onChange={(event) => {
                                                                    let timeTo = event.target.value
                                                                    if (timeTo !== null) {
                                                                        timeTo = timeTo.toString().substr(16, 8)
                                                                        setToHour(timeTo)
                                                                    }
                                                                }}
                                                                value={toHour}
                                                                format={'HH:mm'}
                                                                placeholder="saat"
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <Col md={4}>
                                        <OptionList
                                            label="Sahə (Product Type)"
                                            data={productTypes}
                                            name='productType'
                                            selectedItem={productTyp}
                                            setData={setProductType}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <OptionList
                                            label="Tədbir Növü (Event Type)"
                                            data={eventTypes}
                                            name='eventType'
                                            selectedItem={eventTyp}
                                            setData={setEventType}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <OptionList
                                            label="Status"
                                            data={statList}
                                            name='status'
                                            selectedItem={status}
                                            setData={setStatus}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col>
                                        <input label="Şəkil"
                                               name="imgUrl"
                                               id="upload"
                                               type="file"
                                               accept="image/jpeg,image/png,image/jpg,image/webp,image/gif"
                                               className={`form-control shadow-none`}
                                               onChange={(e) => {
                                                   const file = e.target.files[0]
                                                   setSelectedFile(file)
                                                   UploadFile(file)
                                               }}
                                        />
                                    </Col>
                                </Row>

                                <TextField label="Youtube Link" name="youtubeLink" type="text" enableLabel='true' />
                                <TextField label="Qiymət" name="price" type="text" enableLabel='true' />
                            </Modal.Body>
                            <Modal.Footer>
                                <button type="reset"
                                        className="btn btn-danger mr-3"
                                        onClick={() => {
                                            setShowModal(false)
                                            setShowDeleteModal(true)
                                        }}
                                        data-dismiss="modal">Mehsulu sil</button>
                                <button type="submit"
                                        onClick={() => {
                                            setSubmitClicked(true)
                                            setFileUploadClicked(false)
                                        }}
                                        className="btn btn-primary">Yadda saxla</button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                </>
            )}
        </Formik>
    )
};

export default EditDataModal;
